import React from 'react';
import { graphql } from 'gatsby';
import Helmet from 'react-helmet';
import Fuse from 'fuse.js';
import GlobalNav from '../components/GlobalNav';
import BlogLayout from '../layouts/blog';
import { SearchInput } from '../components/SearchInput';
import { Pagination } from '../components/Pagination';
import HeaderLeft from '../components/headers/HeaderLeft';
import {
  BlogReadingList,
  Categories,
  FeaturedAuthors,
  BlogPostCard,
  FeaturedBlogBanner,
  EmptyBlogs,
  BlogContentWrapper,
  SectionHeader,
} from '../components/blog';

class IndexPage extends React.Component {
  constructor() {
    super();
    this.state = { q: '' };
  }

  componentDidMount() {
    /*  if (!window.Paperform) {
      var script = document.createElement('script')
      script.src = 'https://paperform.co/__embed.min.js'
      document.body.appendChild(script)
    } */
    this.fuse = new Fuse(this.props.data.allGhostPost.edges, {
      keys: [
        'node.title',
        'node.meta_title',
        'node.meta_description',
        'node.excerpt',
        'node.tags.name',
        'node.authors.name',
      ],
    });
  }

  getPage() {
    if (this.state.q) {
      return 1;
    }
    const search = (this.props.location.search || '')
      .split('?')
      .pop()
      .split('&')
      .reduce((res, str) => {
        const part = str.split('=');
        res[part[0]] = part[1];
        return res;
      }, {});

    return (search && search.page && Number(search.page)) || 1;
  }

  render() {
    const {
      data: {
        allGhostPost: { edges },
      },
    } = this.props;

    const categories = {};
    edges.reduce((list, { node }) => {
      node.tags.forEach(({ slug, name }) => {
        if (list.indexOf(slug) === -1) {
          list.push(slug);
          categories[slug] = name;
        }
      });
      return list;
    }, []);

    const hash =
      (this.props.location.hash && this.props.location.hash.replace('#', '')) ||
      '';
    const page = this.getPage() - 1;
    const featured = [];
    let articles = edges.filter(({ node }) => {
      const isHidden = node.tags.find((x) => x.slug === 'hidden');
      if (isHidden) return false;
      if (node.featured) {
        featured.push({ node });
      }
      if (!hash) return true;
      return node.tags && node.tags.find((x) => x.slug === hash);
    });

    if (this.state.q) {
      articles = this.fuse.search(this.state.q).map(({ item }) => item);
    }

    const PER_PAGE = 20;

    if (!hash && !this.state.q) {
      articles = articles.slice(page * PER_PAGE, (page + 1) * PER_PAGE);
    }

    return (
      <BlogLayout location={this.props.location}>
        <GlobalNav />
        <Helmet>
          <title>Paperform Blog</title>
          <html lang="en" />
          <meta
            name="description"
            content="Helpful guides, inspiring stories, and product updates from Paperform."
          />
          {/** remove canonical as it breaks pagination SEO <link rel="canonical" href="https://paperform.co/blog" /> */}
          <link rel="shortcut icon" href="/favicon.ico" type="image/png" />
          <meta property="og:site_name" content="Paperform Blog" />
          <meta
            property="article:publisher"
            content="https://www.facebook.com/paperform.co"
          />
        </Helmet>
        <HeaderLeft
          title="The Formula."
          description="Real-life stories, trends, and strategies to help you grow your business."
          image="/website/logo-v3/graphics/4-3.svg"
          wrapperClass="!bg-gold lg:pl-12"
        />
        <BlogContentWrapper>
          {featured.length > 0 && (
            <FeaturedBlogBanner featuredArticle={featured[0].node} />
          )}

          <SearchInput
            className="mt-12"
            onChange={(e) => this.setState({ q: e.target.value })}
            value={this.state.q}
          />

          <Categories activeCategory={hash} hide={this.state.q} />
          {!this.state.q && <SectionHeader label="New" />}
          <div className="flex flex-wrap justify-center gap-8">
            {this.state.q && !articles.length ? (
              <EmptyBlogs search={this.state.q} />
            ) : null}

            {articles.map(({ node }, i) => (
              <BlogPostCard key={node.slug} node={node} />
            ))}
          </div>
          {!this.state.q && <Pagination nextPage="/blog/2/" />}
          <BlogReadingList />
          <FeaturedAuthors />
        </BlogContentWrapper>
      </BlogLayout>
    );
  }
}

export default IndexPage;

export const query = graphql`
  query BlogQuery {
    allGhostPost(sort: { order: DESC, fields: [published_at] }) {
      edges {
        node {
          id
          slug
          title
          meta_title
          meta_description
          feature_image
          featured
          excerpt
          primary_author
          authors {
            name
            slug
            profile_image
          }
          tags {
            name
            id
            slug
          }
          published_at
        }
      }
    }
  }
`;
